<div class="viewjob-hero">
  <app-breadcrumbs></app-breadcrumbs>
  <!-- Decorative orbs and wave to match the Apple-like hero -->
  <svg class="hero-orb orb-a" viewBox="0 0 400 400" aria-hidden="true" focusable="false">
    <defs>
      <radialGradient id="viewJobOrbGradientA" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#75b6e7" stop-opacity="0.6"/>
        <stop offset="100%" stop-color="#75b6e7" stop-opacity="0"/>
      </radialGradient>
    </defs>
    <circle cx="200" cy="200" r="200" fill="url(#viewJobOrbGradientA)"/>
  </svg>
  <svg class="hero-orb orb-b" viewBox="0 0 400 400" aria-hidden="true" focusable="false">
    <defs>
      <radialGradient id="viewJobOrbGradientB" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#ffffff" stop-opacity="0.35"/>
        <stop offset="100%" stop-color="#ffffff" stop-opacity="0"/>
      </radialGradient>
    </defs>
    <circle cx="200" cy="200" r="200" fill="url(#viewJobOrbGradientB)"/>
  </svg>
  <svg class="hero-wave" viewBox="0 0 1440 120" preserveAspectRatio="none" aria-hidden="true" focusable="false">
    <path d="M0,40 C240,100 480,0 720,40 C960,80 1200,20 1440,60 L1440,120 L0,120 Z" fill="#f6f6f6"></path>
  </svg>
</div>
<div class="title-container-1">
  <div class="title-container-2">
    <div class="search-text"></div>
  </div>
</div>

<div class="container-1">
  <div #notAvailableRef class="container-2 scroll-fade">
    <div class="left apple-card">
      <div class="title">Vacature niet gevonden</div>
      <div class="information">
        <div>Sorry, we hebben de vacature niet kunnen vinden! Maak je echter niet druk, we gaan vanzelf terug naar het vacatureoverzicht.</div>
      </div>
      <div>
        <button class="apple-cta apple-cta--blue" (click)="navigateTo('home')">
          <span>We gaan vanzelf terug in <span class="countdown ml-1">{{countdown}}</span>s</span>
          <icon name="navigate_next"></icon>
        </button>
      </div>
    </div>
  </div>
</div>

@if (!isLoadingJob && isPublished) {
  <div #viewJobRef class="view-job">
    <div class="job-container">
      <div class="vacancies">
        <div #vacancyRef class="vacancy">
          <button class="back-to-jobs" (click)="backToJobs()">
            <icon name="navigate_next" class="back-chevron"></icon>
            <span>Terug naar vacatures</span>
          </button>
          <div class="vacancy-header">{{job.title}}</div>
          <div class="vacancy-apply">
            <button class="apple-cta apple-cta--blue" (click)="directApply($event)">
              <span>Solliciteer direct</span>
              <icon name="navigate_next"></icon>
            </button>
          </div>
          <div class="vacancy-filter-container">
            <div class="vacancy-filter-left">
              <div class="vacancy-filter-row">
                <icon name="location_on_filled"></icon>
                <div class="vacancy-filter-row-container">
                  <span>Locatie</span>
                  <span class="vacancy-type">{{job.location.city}}</span>
                </div>
              </div>
              <div class="vacancy-filter-row">
                <icon name="business"></icon>
                <div class="vacancy-filter-row-container">
                  <span>Functiegebieden</span>
                  <div class="vacancy-type">{{mapIndustries(job)}}</div>
                </div>
              </div>
              <div class="vacancy-filter-row">
                <icon name="school_filled"></icon>
                <div class="vacancy-filter-row-container">
                  <span>Opleidingsniveau</span>
                  <span class="vacancy-type">{{job.education}}</span>
                </div>
              </div>
            </div>
            <div class="vacancy-filter-right">
              <div class="vacancy-filter-row">
                <icon name="euro"></icon>
                <div class="vacancy-filter-row-container">
                  <span>Salaris</span>
                  <span class="vacancy-type">{{parseSalary(job.salary)}}</span>
                </div>
              </div>
              <div class="vacancy-filter-row">
                <icon name="schedule_filled"></icon>
                <div class="vacancy-filter-row-container">
                  <span>Dienstverband</span>
                  <span class="vacancy-type">{{job.employment}}</span>
                </div>
              </div>
              <div class="vacancy-filter-row">
                <icon name="hourglass_filled"></icon>
                <div class="vacancy-filter-row-container">
                  <span>Uren</span>
                  <span class="vacancy-type">{{parseHours(job)}}</span>
                </div>
              </div>
            </div>
          </div>
          @if (job.description) {
            <div class="vacancy-description">
              <div class="vacancy-text jd-root" [innerHTML]="formattedDescription"></div>
            </div>
          }
          <div class="vacancy-apply second">
            <button class="apple-cta apple-cta--blue" (click)="directApply($event)">
              <span>Solliciteer direct</span>
              <icon name="navigate_next"></icon>
            </button>
          </div>
          <div class="date">
            <div class="vacancy-time">Geplaatst: {{dateToDatePosted(job.publicationDate)}}</div>
            <!-- <div class="vacancy-time">Laatst geupdate: {{dateToDatePosted(job?.dateModified)}}</div> -->
          </div>
        </div>
      </div>
      <div class="more-info">
        <div class="recruiter" #recruiterRef>
          <div class="recruiter-title mb-2">Recruiter — {{job.recruiter?.firstName}} {{job.recruiter?.lastName}}</div>
          <div class="recruiter-content">
            <!-- <img class="recruiter-image" src="assets/avatar_unknown.png"> -->
            <div class="recruiter-info flex flex-col gap-2">
              @if (job.recruiter?.phoneNumber; as phone) {
                <div class="info">
                  <icon name="call_filled"></icon>
                  <div class="info-text" (click)="phoneCall(formatE164(phone))">
                    <span class="flag">{{getPhoneFlag(phone)}}</span>
                    <span class="number">{{getPhoneDisplay(phone)}}</span>
                  </div>
                </div>
              } @else {
                <div class="info">
                  <icon name="call_filled"></icon>
                  <div class="info-text not-available">Niet beschikbaar</div>
                </div>
              }
              <div class="info">
                <icon name="email_filled" ></icon>
                <div class="info-text" (click)="email(job.recruiter?.userName || '')"><span class="number">{{job.recruiter?.userName}}</span></div>
              </div>
              @if (job.recruiter?.phoneNumber; as phone) {
                <div class="info">
                  <icon name="whatsapp"></icon>
                  <div class="info-text" (click)="whatsapp(toWhatsAppNumber(phone))"><span class="number">Vragen? Whatsapp!</span></div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="related-jobs" >
          <div #relatedJobsTitleRef class="related-jobs-title">
            <div class="text">Gerelateerde vacatures</div>
            <apple-multiselect
              [multiple]="false"
              [options]="['Publicatie datum', 'A-Z']"
              [ngModel]="relatedVacanciesToggleDisplay"
              (ngModelChange)="onRelatedVacanciesToggleChange($event)"
              placeholder="Sorteer op"
              class="related-jobs-select">
            </apple-multiselect>
          </div>
          @if (relatedJobs.length > 0) {
            <div #relatedJobsContainerRef class="related-jobs-container">
              @for (relatedJob of relatedJobs; track relatedJob) {
                <div
                  matRipple
                  matRippleColor="rgb(47, 47, 47, 0.1)"
                  class="related-job"
                  (click)="viewJob($event, relatedJob)">
                  <div class="related-job-content">
                    <div>{{relatedJob.title}}</div>
                    <icon class="related-job-icon" name="navigate_next" ></icon>
                  </div>
                </div>
              }
            </div>
          }
          @if (relatedJobs.length === 0 && isLoadingRelatedJobs) {
            <div class="no-related-jobs">
              <div>Zoeken naar gerelateerde vacatures...</div>
              <mat-spinner class="no-related-jobs-spinner" [diameter]="20"></mat-spinner>
            </div>
          }
          @if (relatedJobs.length === 0 && !isLoadingRelatedJobs) {
            <div class="no-related-jobs">
              We hebben geen gerelateerde vacatures kunnen vinden.
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (isLoadingJob) {
  <div #viewJobRef class="view-job">
    <div class="job-container">
      <div class="vacancies">
        <div #vacancyRef class="vacancy">
          <div class="vacancy-header-skeleton skeleton-box"></div>
          <div class="vacancy-apply">
            <div class="vacancy-apply-button-skeleton skeleton-box"></div>
          </div>
          <div class="vacancy-filter-container">
            <div class="vacancy-filter-left">
              <div class="vacancy-filter-row">
                <div class="job-description-bullet-skeleton skeleton-box" style="width: 20px; height: 20px;"></div>
                <div class="vacancy-filter-row-container">
                  <span class="vacancy-type-skeleton skeleton-box"></span>
                  <div class="margin-small-skeleton"></div>
                  <span class="vacancy-type-skeleton skeleton-box"></span>
                </div>
              </div>
              <div class="vacancy-filter-row">
                <div class="job-description-bullet-skeleton skeleton-box" style="width: 20px; height: 20px;"></div>
                <div class="vacancy-filter-row-container">
                  <span class="vacancy-type-skeleton skeleton-box"></span>
                  <div class="margin-small-skeleton"></div>
                  <span class="vacancy-type-skeleton skeleton-box"></span>
                </div>
              </div>
              <div class="vacancy-filter-row">
                <div class="job-description-bullet-skeleton skeleton-box" style="width: 20px; height: 20px;"></div>
                <div class="vacancy-filter-row-container">
                  <span class="vacancy-type-skeleton skeleton-box"></span>
                  <div class="margin-small-skeleton"></div>
                  <span class="vacancy-type-skeleton skeleton-box"></span>
                </div>
              </div>
            </div>
            <div class="vacancy-filter-right">
              <div class="vacancy-filter-row">
                <div class="job-description-bullet-skeleton skeleton-box" style="width: 20px; height: 20px;"></div>
                <div class="vacancy-filter-row-container">
                  <span class="vacancy-type-skeleton skeleton-box"></span>
                  <div class="margin-small-skeleton"></div>
                  <span class="vacancy-type-skeleton skeleton-box"></span>
                </div>
              </div>
              <div class="vacancy-filter-row">
                <div class="job-description-bullet-skeleton skeleton-box" style="width: 20px; height: 20px;"></div>
                <div class="vacancy-filter-row-container">
                  <span class="vacancy-type-skeleton skeleton-box"></span>
                  <div class="margin-small-skeleton"></div>
                  <span class="vacancy-type-skeleton skeleton-box"></span>
                </div>
              </div>
              <div class="vacancy-filter-row">
                <div class="job-description-bullet-skeleton skeleton-box" style="width: 20px; height: 20px;"></div>
                <div class="vacancy-filter-row-container">
                  <span class="vacancy-type-skeleton skeleton-box"></span>
                  <div class="margin-small-skeleton"></div>
                  <span class="vacancy-type-skeleton skeleton-box"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="vacancy-description">
            <div class="job-description-header-skeleton skeleton-box"></div>
            <div class="margin-skeleton"></div>
            <div class="job-description-sub-header-skeleton skeleton-box"></div>
            <div class="margin-skeleton"></div>
            <div class="job-description-paragraph-skeleton skeleton-box"></div>
            <div class="margin-small-skeleton"></div>
            <div class="job-description-paragraph-skeleton skeleton-box" style="width: 25%;"></div>
            <div class="margin-skeleton"></div>
            <div class="job-description-paragraph-skeleton skeleton-box"></div>
            <div class="margin-small-skeleton"></div>
            <div class="job-description-paragraph-skeleton skeleton-box" style="width: 99%;"></div>
            <div class="margin-small-skeleton"></div>
            <div class="job-description-paragraph-skeleton skeleton-box" style="width: 60%;"></div>
            <div class="margin-skeleton"></div>
            <div class="job-description-paragraph-skeleton skeleton-box"></div>
            <div class="margin-small-skeleton"></div>
            <div class="job-description-paragraph-skeleton skeleton-box" style="width: 99%;"></div>
            <div class="margin-small-skeleton"></div>
            <div class="job-description-paragraph-skeleton skeleton-box" style="width: 75%;"></div>
            <div class="margin-skeleton"></div>
            <div class="job-description-paragraph-skeleton skeleton-box"></div>
            <div class="margin-small-skeleton"></div>
            <div class="job-description-paragraph-skeleton skeleton-box" style="width: 99%;"></div>
            <div class="margin-small-skeleton"></div>
            <div class="job-description-paragraph-skeleton skeleton-box" style="width: 98%;"></div>
            <div class="margin-small-skeleton"></div>
            <div class="job-description-paragraph-skeleton skeleton-box"></div>
            <div class="margin-small-skeleton"></div>
            <div class="job-description-paragraph-skeleton skeleton-box" style="width: 30%;"></div>
            <div class="margin-skeleton"></div>
            @for (i of [0, 1, 2]; track i) {
              <div class="job-description-sub-header-skeleton skeleton-box"></div>
              <div class="margin-skeleton"></div>
              <div class="job-description-bullet-container-skeleton">
                <div class="job-description-bullet-skeleton skeleton-box" style="width: 15px;"></div>
                <div class="job-description-paragraph-skeleton skeleton-box" style="width: 80%;"></div>
              </div>
              <div class="margin-small-skeleton"></div>
              <div class="job-description-bullet-container-skeleton">
                <div class="job-description-bullet-skeleton skeleton-box" style="width: 15px;"></div>
                <div class="job-description-paragraph-skeleton skeleton-box" style="width: 60%;"></div>
              </div>
              <div class="margin-small-skeleton"></div>
              <div class="job-description-bullet-container-skeleton">
                <div class="job-description-bullet-skeleton skeleton-box" style="width: 15px;"></div>
                <div class="job-description-paragraph-skeleton skeleton-box" style="width: 70%;"></div>
              </div>
              <div class="margin-small-skeleton"></div>
              <div class="job-description-bullet-container-skeleton">
                <div class="job-description-bullet-skeleton skeleton-box" style="width: 15px;"></div>
                <div class="job-description-paragraph-skeleton skeleton-box" style="width: 65%;"></div>
              </div>
              <div class="margin-skeleton"></div>
            }
          </div>
          <div class="vacancy-apply second">
            <div class="vacancy-apply-button-skeleton skeleton-box"></div>
          </div>
          <div class="date">
            <div class="vacancy-time">
              <div class="job-description-paragraph-skeleton skeleton-box" style="width: 20%;"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="more-info">
        <div class="recruiter">
          <div class="job-description-sub-header-skeleton skeleton-box" style="height:40px;"></div>
          <div class="margin-small-skeleton"></div>
          <div class="recruiter-content">
            <div class="recruiter-info">
              <div class="info">
                <div class="job-description-bullet-skeleton skeleton-box" style="width: 20px; height: 20px;"></div>
                <span class="vacancy-type-skeleton skeleton-box"></span>
              </div>
              <div class="info">
                <div class="job-description-bullet-skeleton skeleton-box" style="width: 20px; height: 20px;"></div>
                <span class="vacancy-type-skeleton skeleton-box" style="width:200px;"></span>
              </div>
              <div class="info">
                <div class="job-description-bullet-skeleton skeleton-box" style="width: 20px; height: 20px;"></div>
                <span class="vacancy-type-skeleton skeleton-box" style="width:160px;"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="related-jobs">
          <div class="related-jobs-title">
            <div class="job-description-sub-header-skeleton skeleton-box" style="height:40px;"></div>
            <div class="margin-skeleton"></div>
          </div>
          <div class="no-related-jobs first">
            <div class="job-description-paragraph-skeleton skeleton-box"></div>
            <div class="margin-small-skeleton"></div>
          </div>
          <div class="no-related-jobs">
            <div class="job-description-paragraph-skeleton skeleton-box"></div>
            <div class="margin-small-skeleton"></div>
          </div>
          <div class="no-related-jobs">
            <div class="job-description-paragraph-skeleton skeleton-box"></div>
            <div class="margin-small-skeleton"></div>
          </div>
          <div class="no-related-jobs">
            <div class="job-description-paragraph-skeleton skeleton-box"></div>
            <div class="margin-small-skeleton"></div>
          </div>
          <div class="no-related-jobs">
            <div class="job-description-paragraph-skeleton skeleton-box"></div>
            <div class="margin-small-skeleton"></div>
          </div>
          <div class="no-related-jobs">
            <div class="job-description-paragraph-skeleton skeleton-box"></div>
            <div class="margin-small-skeleton"></div>
          </div>
          <div class="no-related-jobs">
            <div class="job-description-paragraph-skeleton skeleton-box"></div>
            <div class="margin-small-skeleton"></div>
          </div>
          <div class="no-related-jobs">
            <div class="job-description-paragraph-skeleton skeleton-box"></div>
            <div class="margin-small-skeleton"></div>
          </div>
          <div class="no-related-jobs last">
            <div class="job-description-paragraph-skeleton skeleton-box"></div>
            <div class="margin-small-skeleton"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
}